.badge {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 5.6rem;
  height: 5.6rem;
  background-color: var(--color-action-primary--disabled);
  border-radius: 2.4rem;
}

.icon {
  width: 2.4rem;
  height: 2.4rem;
}
